









































































































































module.exports =
  name: 'about_hm_modal'
  components: `{
    planning_modal: () => import(/* webpackChunkName: "planning_modal" */'../onboarding/planning_modal.vue')
  }`
  data: ->
    modal_step: 0
  computed:
    display_about_hm_modal: -> !@$store.getters.hidden_tooltips.includes('about_hm_modal')
    planning_modal_visible: -> @$store.state.ui.forecast.planning_modal_visible
  methods:
    hide: ->
      @$store.dispatch 'hideTooltip', 'about_hm_modal'
      if HM.is_mobile
        @$router.push { name: 'mobile_accounts_page' }
      else
        @$router.push { name: 'accounts_page' }
  watch:
    display_about_hm_modal: -> @modal_step = 0
    modal_step: -> @$nextTick -> $(".modal.is-active .modal-card-body").scrollTop(0)
